import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'store-details-stencil',
  template: `
    <div class="details">
      <mat-card appearance="outlined" class="details-header">
        <div class="details-column-0">
          <div class="details-column-0-1">
            <div class="details-icon stencil-shimmer"></div>
          </div>
          <div class="details-column-0-2">
            <div class="details-title stencil-shimmer"></div>
            <div class="details-title stencil-shimmer"></div>
          </div>
        </div>
        <div class="details-column-1">
          <div class="details-column-1-0 stencil-shimmer"></div>
          <div class="details-column-1-1 stencil-shimmer"></div>
        </div>
      </mat-card>

      <mat-card appearance="outlined">
        <div class="details-box-large stencil-shimmer"></div>
      </mat-card>

      <mat-card appearance="outlined" class="details-body">
        <div class="details-body-column-0">
          <div class="details-icon-small stencil-shimmer"></div>
          <div class="details-icon-small stencil-shimmer"></div>
          <div class="details-icon-small stencil-shimmer"></div>
          <div class="details-icon-small stencil-shimmer"></div>
          <div class="details-icon-small stencil-shimmer"></div>
          <div class="details-icon-small stencil-shimmer"></div>
          <div class="details-icon-small stencil-shimmer"></div>
        </div>
        <div class="details-body-column-1">
          <div class="details-line stencil-shimmer"></div>
          <div class="details-line stencil-shimmer"></div>
          <div class="details-line stencil-shimmer"></div>
          <div class="details-line stencil-shimmer"></div>
          <div class="details-line stencil-shimmer"></div>
          <div class="details-line stencil-shimmer"></div>
          <div class="details-line stencil-shimmer"></div>
        </div>
        <div class="details-body-column-2">
          <div class="details-box stencil-shimmer"></div>
          <div class="details-box stencil-shimmer"></div>
          <div class="details-box stencil-shimmer"></div>
          <div class="details-box stencil-shimmer"></div>
          <div class="details-box stencil-shimmer"></div>
        </div>
      </mat-card>
    </div>
  `,
  styleUrls: ['./details-stencil.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DetailsStencilComponent {}
